import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { setToken, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function getSessionIdFromUrl() {
  // Emergent returns the session id in the URL fragment, but be robust to query too.
  const hash = (window.location.hash || "").replace(/^#/, "");
  const search = (window.location.search || "").replace(/^\?/, "");
  const fromHash = new URLSearchParams(hash).get("session_id");
  const fromQuery = new URLSearchParams(search).get("session_id");
  return fromHash || fromQuery || null;
}

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = getSessionIdFromUrl();
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setToken(data.token);
        setUser(data.user);
        // Hard redirect to a clean URL so the app re-boots with the token in storage,
        // avoiding any SPA router-state edge cases during the OAuth return.
        window.location.replace(window.location.origin + "/dashboard");
      } catch (err) {
        const msg = formatApiErrorDetail(err?.response?.data?.detail);
        toast.error(`Google sign-in failed: ${msg}`);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink">
      <div className="text-center">
        <div className="h-8 w-8 rounded-full border-2 border-white/20 border-t-champagne animate-spin mx-auto" />
        <p className="text-zinc-400 text-sm mt-4">Signing you in…</p>
      </div>
    </div>
  );
}
